import Config from './config'

// TODO - This seems wrong.

const production = {
  isLocal: false,
  isProduction: true,
  apiBase: process.env.VUE_APP_API_BASE,
}

// const dev = {
//   ...production,
//   isLocal: true,
//   isProduction: false,
//   apiBase: process.env.VUE_APP_API_BASE,
// }

// initialize config
Config
  .default(production)
  .detect()
export default Config
